import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  nationChartVariables: {
    sdohKey: null,
    stateCode: null,
    stateCountyCode: null
  }
}

const nationChartSlice = createSlice({
  name: 'nationChart',
  initialState,
  reducers: {
    setNationChartVariables: (state, action) => {
      state.nationChartVariables = action.payload
    },
    resetNationChartVariables: (state) => {
      state.nationChartVariables = {sdohKey: null, stateCode: null, stateCountyCode: null}
    }
  }
})

export const {setNationChartVariables, resetNationChartVariables} = nationChartSlice.actions

export const selectNationChartVariables = (state) => state.nationChart.nationChartVariables

export default nationChartSlice.reducer
